import React from 'react';
import { Box, Typography } from '@mui/material';

const OverviewSection = () => {
  const features = [
    {
      title: 'Performance Metrics Monitoring',
      desc: 'Tracks key indicators such as CPU usage, memory usage, disk I/O, and network activity. This helps administrators identify potential bottlenecks and resource exhaustion.',
    },
    {
      title: 'Uptime and Availability Monitoring',
      desc: 'Continuously monitors server availability to ensure services are up and responsive. Alerts are sent instantly in case of downtime.',
    },
    {
      title: 'Resource Utilization Analysis',
      desc: 'Analyzes how server resources are used over time. This helps forecast future capacity requirements and informs scaling decisions.',
    },
    {
      title: 'Scalability and Elasticity',
      desc: 'Enables infrastructure to adjust according to demand. Performance is tracked during scaling events to ensure systems remain responsive.',
    },
    {
      title: 'Alerting and Notification Systems',
      desc: 'Allows users to set custom thresholds for critical metrics. Notifications are sent when limits are crossed, prompting timely intervention.',
    },
    {
      title: 'Historical Data and Reporting',
      desc: 'Archives historical performance data for long-term trend analysis and retrospective problem-solving.',
    },
    {
      title: 'User-Friendly Dashboards',
      desc: 'Provides customizable dashboards with real-time data visualization, offering clarity to both technical and non-technical users.',
    },
  ];

  return (
    <Box sx={{ px: { xs: 2, sm: 4 }, py: 2 }}>
      {/* Overview */}
      <Typography paragraph>
        If you haven’t yet explored WatchNod, this guide is your starting point. Here, you will learn how WatchNod functions, its key components, and how each feature contributes to maintaining a robust and efficient monitoring environment.
      </Typography>
      <Typography variant="body1" color="text.secondary" gutterBottom>
        Note: WatchNod is an agent-based monitoring platform, which means that the WatchNod agent must be downloaded and installed on every server you wish to monitor.
      </Typography>

      {/* Introduction */}
      <Typography variant="h5" sx={{ mt: 4 }} gutterBottom>
        Introduction to Monitoring Solutions
      </Typography>
      <Typography paragraph>
        In the digital era, web-based services and applications need to operate without interruption. Reliable monitoring of server infrastructure is critical to maintaining performance, availability, and user satisfaction. Monitoring solutions like WatchNod are essential for proactively managing, analyzing, and maintaining servers to prevent issues before they occur and minimize downtime when they do.
      </Typography>

      {/* Features */}
      <Typography variant="h6" sx={{ mt: 4 }} gutterBottom>
        Key Features of Monitoring Solutions
      </Typography>
      <ul style={{ paddingLeft: '1.25rem' }}>
        {features.map((feature, idx) => (
          <li key={idx} style={{ marginBottom: '1rem' }}>
            <Typography variant="subtitle1" component="span" fontWeight="bold">
              {feature.title}
            </Typography>
            <Typography variant="body1" component="p" mt={0.5}>
              {feature.desc}
            </Typography>
          </li>
        ))}
      </ul>
    </Box>
  );
};

export default OverviewSection;
